<template>
  <div class="OptionArticle">
    <div class="topic">
      {{ article.topic }}
    </div>
    <div class="date">
      {{ article.createdAt | relativeTime }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    article: Object,
  },
}
</script>

<style lang="scss">
.OptionArticle {
  display: grid;
  grid-gap: $grid-unit-half;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;

  > .topic {
    font-weight: $semibold;
  }

  > .date {
    font-size: $h6;
  }
}
</style>
